export default __webpack_public_path__ + "static/media/img_fahmid.84e34769.png";